/*
 * @Author: HANG ZHANG
 * @Date: 2020-06-04 20:06:52
 * @Description:
 * @LastEditors: enmingl
 * @LastEditTime: 2020-11-18 10:42:57
 * @FilePath: /vision-h5/src/modules/modal/ModalInstance.js
 */

/**
 * @description: 将Vue组件转化为实例对象（主要用于Modal组件下）
 * @param {}
 * @return:viod
 */
import Vue from 'vue';
let countId = 0;
let instanceList = [];
class Modal {
	constructor(component) {
		this._control = Vue.extend(component);
		return this._initModal;
	}
	_initModal = (options) => {
		options = options || {};
		// 分发自己的ID
		let id = 'modal_' + ++countId;
		// 实例化组件，合并data参数
		let instance = null;
		instance = new this._control({
			data: options,
			propsData: {
				instanceList,
			},
		});
		// 实例配置ID
		instance.id = id;
		// 保存自有关闭回调方法
		let selfOnColse = options.onClose;
		// 重写关闭回调方法，主要是从实例中销毁自己的id
		options.onClose = () => {
			this._close(id, selfOnColse);
		};
		// 文档之外渲染，随后挂载
		instance.$mount();
		let $el = instance.$el;
		// 保证新增实例化层级最高
		// $el.style.zIndex = +countId + 20;
		document.body.appendChild($el);
		// 打开实例
		instance.open();
		instanceList.push(instance);
		return instance;
	};
	_close = (id, callback) => {
		for (let index = 0; index < instanceList.length; index++) {
			const _instance = instanceList[index];
			if (_instance.id === id) {
				if (typeof callback === 'function') {
					callback();
				}
				instanceList.splice(index, 1);
				break;
			}
		}
	};
	// 判断是为Vue组件
	_isComponent = (node) => {
		return node !== null && typeof node === 'object' && Object.prototype.hasOwnProperty.call(node, 'componentOptions');
	};
}

export default Modal;



// WEBPACK FOOTER //
// ./src/modules/modal/ModalInstance.js